import { render, staticRenderFns } from "./audit-idcard-upload.vue?vue&type=template&id=70b5f5a2&scoped=true"
import script from "./audit-idcard-upload.vue?vue&type=script&lang=js"
export * from "./audit-idcard-upload.vue?vue&type=script&lang=js"
import style0 from "./audit-idcard-upload.vue?vue&type=style&index=0&id=70b5f5a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b5f5a2",
  null
  
)

export default component.exports